/* eslint-disable no-undef */
import NiceSelect from "nice-select2";

document.addEventListener('DOMContentLoaded', function () {
    // console.log('modals');

    const modals = {
        cookies: document.getElementById('cookies-modal'),
        marketing: document.getElementById('marketing-modal'),
        search: document.getElementById('search-modal')
    };
    
    const buttons = {
        showCookies: document.querySelectorAll('.show-cookies'),
        showMarketing: document.querySelectorAll('.show-marketing'),
        showSearch: document.querySelectorAll('.show-search'),
        closeCookies: document.querySelectorAll('.cookies-modal__content--close, .cookies-modal__button'),
        closeMarketing: document.querySelectorAll('.marketing-modal__content--close, .marketing-modal__button'),
        closeSearch: document.querySelectorAll('.search-modal__content--close, .search-modal__button')
    };

    const addOpenEvent = (buttons, modal) => {
        if (buttons.length && modal) {
            buttons.forEach(button => {
                button.addEventListener('click', () => {
                    modal.classList.add('show');
                });
            });
        }
    };
    
    const addCloseEvent = (buttons, modal) => {
        if (buttons.length && modal) {
            buttons.forEach(button => {
                button.addEventListener('click', () => {
                    modal.classList.remove('show');
                });
            });
        }
    };
    
    addOpenEvent(buttons.showCookies, modals.cookies);
    addCloseEvent(buttons.closeCookies, modals.cookies);
    addOpenEvent(buttons.showMarketing, modals.marketing);
    addCloseEvent(buttons.closeMarketing, modals.marketing);
    addOpenEvent(buttons.showSearch, modals.search);
    addCloseEvent(buttons.closeSearch, modals.search);

    // const acceptBtn = document.querySelector('.cookies-modal__button.accept');
    // const denyBtn = document.querySelector('.cookies-modal__button.deny');

    // if (acceptBtn) {
    //     acceptBtn.addEventListener('click', function () {
    //         setCookieChoice('accept');
    //     });
    // }

    // if (denyBtn) {
    //     denyBtn.addEventListener('click', function () {
    //         setCookieChoice('reject');
    //     });
    // }

    // function setCookieChoice(choice) {
    //     const cookiesModal = document.getElementById('cookies-modal');

    //     if (choice === 'accept') {
    //         document.cookie = 'moove_gdpr_popup={"strict":true,"thirdparty":true,"advanced":true}; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT';
    //     } else {
    //         document.cookie = 'moove_gdpr_popup={"strict":true,"thirdparty":false,"advanced":false}; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT';
    //     }
        
    //     cookiesModal.classList.remove('show');
    // }

    function marketingToogleChoice() {
      const toggleMarketing = document.getElementById("marketing-toggle");
  
      if (toggleMarketing) {
          if (localStorage.getItem('marketingPreference') === null) {
              localStorage.setItem('marketingPreference', "1");
          }
  
          const savedState = localStorage.getItem('marketingPreference');
          toggleMarketing.checked = savedState === "1";
  
          toggleMarketing.addEventListener("change", function () {
              localStorage.setItem('marketingPreference', toggleMarketing.checked ? "1" : "0");
          });
      }
  }
    marketingToogleChoice();

        function niceSelect() {
            let select = document.getElementById('dealers-region-form');
      
            if (select) {
              const selectedOption = select.options[select.selectedIndex];
              const placeholderText = selectedOption && selectedOption.value ? selectedOption.value : 'Region';
            
              const options = {
                searchable: true,
                placeholder: placeholderText,
                searchtext: 'Välj',
              };
          
              let instance = new NiceSelect(select, options);
        
              setTimeout(() => {
                const searchInputs = document.querySelectorAll('.nice-select-search-box input');
                
                function normalizeText(text) {
                  return text
                    .replace(/\s+/g, '') // Ignore spacing
                    .replace(/[üÜ]/g, 'u') // Replace letter "Ü"
                    .replace(/[öÖ]/g, 'o') // Replace letter "Ö"
                    .replace(/[äÄ]/g, 'a') // Replace letter "Ä"
                    .replace(/[åÅ]/g, 'a') // Replace letter "Å"
                    .toLowerCase();
                }
          
                searchInputs.forEach(input => {
                  const list = input.closest('.nice-select').querySelector('.list');
                  const listItems = list.querySelectorAll('li');
          
                  input.addEventListener('input', function () {
                    const searchValue = normalizeText(input.value);
          
                    listItems.forEach(item => {
                      const text = normalizeText(item.textContent);
                      if (text.includes(searchValue)) {
                        item.style.display = '';
                      } else {
                        item.style.display = 'none';
                      }
                    });
                  });
                });
              }, 100);
            } else {
              console.warn('No element found with ID');
            }
        }
        
        niceSelect();

        function dealersReginSearch(){
            const btnSearch   = document.getElementById('dealers-search-btn');
            const selectField = document.getElementById('dealers-region-form');
          
            if (btnSearch && selectField) {
            btnSearch.addEventListener('click', function(e) {
              e.preventDefault();

              let regionValue = selectField.value.trim();
              let selectedValue = ''; // Default value
              const mainContent = document.getElementById('main-content');
              const defaultChoice = mainContent ? mainContent.dataset.defaultChoice : null;

              if (defaultChoice === 'husvagn') {
                selectedValue = 'husvagn';
              } else if (defaultChoice === 'husbil') {
                selectedValue = 'husbil';
              }
          
              let url = '/dealers/';
              const params = new URLSearchParams();
              
              if (regionValue) {
                params.append('region', regionValue);
              }
              if (selectedValue) {
                params.append('type', selectedValue);
              }
              
                window.location.href = url + '?' + params.toString();
              });
            }
        }
        dealersReginSearch();

        function searchModel() {
          let button = document.querySelector('.search-modal__button');
          if (!button) return;

          button.addEventListener('click', function() {
            let inputValue = document.querySelector('.search-modal__input').value;
            let targetModel = document.getElementById('modell');
            let targetModelHus = document.getElementById('modell-hus');
            let hiddenModelVal = document.getElementById('modellValue');
            let hiddenModelValHus = document.getElementById('modellValue-hus');

            localStorage.setItem('vincents-husbil-model', inputValue);
            localStorage.setItem('vincents-husvagn-model', inputValue);

            let husvagnModel = localStorage.getItem('vincents-husvagn-model') || '';
            let husbilModel = localStorage.getItem('vincents-husbil-model') || '';
        
            if (targetModel) {
                targetModel.value = inputValue;
                targetModel.dataset.value = 'other';
                hiddenModelVal.value = inputValue;
                console.log('husbilModel '+ husbilModel);
            }
            if (targetModelHus) {
              targetModelHus.value = inputValue;
              targetModelHus.dataset.value = 'other';
              hiddenModelValHus.value = inputValue;
              console.log('husvagnModel ' + husvagnModel);
            }


          });
        }

        searchModel();
});
